/* eslint-disable jsx-a11y/alt-text */
import { WbGridCol, WbGridRow, WbHeading, WbTab, WbTabContent, WbTabs, WbText } from '@workbench/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { useSiteStyles } from '../../../Contexts/StyleContext';
import RDBox from '../../Common/RDBox/RDBox';
import RDivider from '../../Common/RDivider/RDivider';
import '../../Demo/DemoTabs/DemoTabs.scss';
import { TabContents, chooseTabContent } from '../TabContents/TabContents';

const useStyles = createUseStyles((theme) => ({
    siteStyles: (siteStyles) => ({
        border: siteStyles.border,
        key: siteStyles.key,
    }),
}));
function VehicleTabs(props) {
    const { infoList, steveData, equipmentImages } = props;
    const { t } = useTranslation();

    const checkTabExteriorOrInterior = (tab) => tab.name === "exterior" || tab.name === "interior";

    const { siteStyles } = useSiteStyles();
    const classes = useStyles(siteStyles);

    const equipmentHighlightFilter = (tab) => {
        if (siteStyles.key === "equipment" && tab.name !== "generalData") {
            return "equipmentHighlight";
        } else if (siteStyles.key === "specifications") {
            return "specificationsHighlight";
        }
    }

    const chooseSelectedTab = () => {
        if (siteStyles.key === "equipment") {
            return "packages";
        }
        return "generalData";
    }

    return (
        <RDBox className="rd-demo-content">
            <WbTabs className="rd-demo-content__tabs" selected={chooseSelectedTab()}>
                {infoList.tabs.map((tab) => (
                    <React.Fragment key={tab.name}>
                        <WbTab className={`${equipmentHighlightFilter(tab) === "equipmentHighlight" ? classes.siteStyles : null} ${equipmentHighlightFilter(tab) === "specificationsHighlight" ? classes.siteStyles : null} `} name={tab.name}>{t(`demoTabs.dataTabs.${tab.name}`)}</WbTab>
                        <WbTabContent name={tab.name} slot="content" className={`rd-demo-content__tab ${equipmentHighlightFilter(tab) === "specificationsHighlight" && tab.name === "generalData" ? classes.siteStyles : null} `}>
                            {(checkTabExteriorOrInterior(tab) && equipmentImages) && (
                                <>
                                    <WbGridRow className="rd-demo-line-content">
                                        <WbGridCol mq3={6} mq1={8}>
                                            <RDBox className="rd-demo-image-box">
                                                <img className="rd-demo-lineImage" src={tab.name === "exterior" ? equipmentImages?.PAINT?.A31 || equipmentImages?.PAINT?.A34 : equipmentImages?.UPHOLSTERY?.A31 || equipmentImages?.UPHOLSTERY?.A34} />
                                                <RDBox className="rd-demo-image-box-description">
                                                    <WbText>{tab.name === "exterior" ? t("demoTabs.paint") : t("demoTabs.upholstery")}</WbText>
                                                    <WbText>{tab.name === "exterior" ? equipmentImages?.PAINT?.desc?.text : equipmentImages?.UPHOLSTERY?.desc?.text}</WbText>
                                                </RDBox>
                                            </RDBox>
                                        </WbGridCol>
                                        {tab.name === "exterior" && (
                                            <WbGridCol mq3={6} mq1={4}>
                                                <RDBox className="rd-demo-line-box">
                                                    <WbText>{t("demoTabs.lack")}</WbText>
                                                    <WbText>Metallic</WbText>
                                                </RDBox>
                                            </WbGridCol>
                                        )}
                                    </WbGridRow>
                                    <RDivider />
                                </>
                            )}
                            <WbHeading size="xs" className="rd-demo-content__heading">
                                {t(`demoTabs.dataTabs.${tab.name}`)}
                            </WbHeading>
                            <WbGridRow>
                                <TabContents tab={tab} vehicleData={infoList} steveData={steveData} equipmentImages={equipmentImages} equipmentHighlightFilter={equipmentHighlightFilter(tab)} className="rd-demo-content__element">
                                    {chooseTabContent(tab.type)}
                                </TabContents>
                            </WbGridRow>
                        </WbTabContent>
                    </React.Fragment>
                ))}
            </WbTabs>
        </RDBox>
    );
}

export default VehicleTabs;